import React from "react";

import * as Styled from "./styles";

const Card = ({ children }) => {
  return <Styled.Container>{children}</Styled.Container>;
};

export default Card;
